import React, { createContext, useContext } from 'react';
import setNotifications from '@utils/openNotification';

// Create a context for notifications
const NotificationContext = createContext<any>(null);

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider: React.FC<any> = ({ api, children }) => {
  // Initialize the openNotification function using the notification API
  const openNotification = setNotifications(api);
  return (
    <NotificationContext.Provider value={openNotification}>
      {children}
    </NotificationContext.Provider>
  );
};
